<template>
  <div class="consult">
    <div class="select">
      <div class="consult-title">为什么选择学习<span class="e75">小语种？</span></div>
      <div class="select-list">
        <div class="select-item" v-for="(item,index) in selectList" :key="index">
          <div class="select-icon">
            <img :src="item.icon" alt="">
          </div>
          <div class="select-content">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <div class="consult-btn" @click="showService()" data-agl-cvt="1">在线咨询</div>
      <div style="margin-top:36px;height:1px;height:1px;background:#e4e4e4"></div>
    </div>
    <div class="FQA">
      <div class="consult-title">小语种常见问题<span class="e75">Q&A</span></div>
      <div class="FQA-list">
        <div class="FQA-item" v-for="(item,index) in FQAList" :key="index">
          <div class="FQA-title">
            Q{{index+1}}：{{item.title}}
          </div>
          <div class="FQA-content">
            {{item.content}}
          </div>
        </div>
        <div class="consult-btn" @click="showService()" data-agl-cvt="1">在线咨询</div>
      </div>
    </div>
    <div class="advantage">
      <div class="consult-title">我们的<span class="e75">优势</span></div>
      <div class="advantage-list">
        <div class="advantage-item" v-for="(item,index) in advantageList " :key="index">
          <div class="advantage-icon">
            <img :src="item.icon" alt="">
          </div>
          <div class="advantage-content">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <div class="consult-btn" @click="showService()" data-agl-cvt="1">在线咨询</div>
    </div>
  </div>
</template>
<script>
import { selectList, FQAList, advantageList } from "../jsons/staticjson"
export default {
  name: "ConsultPage",
  data() {
    return {
      selectList, FQAList, advantageList
    }
  },
  methods: {
    showService() {
      this.$emit("service")
    }
  }
}
</script>

<style lang="scss" scoped>
.consult-title {
  font-size: 48px;
  font-family: gb;
  font-weight: 600;
  color: #122753;
  text-align: center;
  span {
    font-family: gb;
    font-weight: 600;
  }
}
.consult-btn {
  width: 263px;
  height: 56px;
  background-color: #fe556c;
  box-shadow: 0px 3px 2px 0px rgba(134, 138, 183, 0.24);
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 23px;
  font-family: gb;
  font-weight: 600;
  margin: 0 auto;
  margin-top: 90px;
  cursor: pointer;
}

.consult {
  .select {
    margin-top: 116px;
    .select-list {
      display: flex;
      justify-content: space-between;
      margin-top: 86px;
      .select-item {
        width: 280px;
        height: 250px;
        border-radius: 16px;
        background-color: #fff;
        .select-icon {
          height: 160px;
        }

        .select-content {
          display: flex;
          align-items: center;
          height: 90px;
          div {
            text-align: center;
            line-height: 22px;
          }
        }
      }
    }
  }

  .FQA {
    margin-top: 116px;
    .FQA-list {
      margin-top: 68px;
      .FQA-item {
        color: #333;
        margin-top: 50px;
        .FQA-title {
          font-family: gb;
          font-weight: 600;
          font-size: 20px;
        }
        .FQA-content {
          font-size: 18px;
          margin-top: 12px;
          line-height: 30px;
        }
      }
    }
  }
  .advantage {
    margin-top: 186px;
    .advantage-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .advantage-item {
        width: 360px;
        height: 120px;
        display: flex;
        background-color: #fff;
        margin-top: 50px;
        .advantage-icon {
          width: 120px;
          height: 120px;
        }

        .advantage-content {
          flex: 1;
          display: flex;
          align-items: center;
          padding-left: 42px;
          div {
            line-height: 36px;
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
